import {
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

interface YesNoRadioButtonProps {
  label: string;
  isHorizontal?: boolean;
  required?: boolean;
  disabled?: boolean;
}

const YES_NO_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const YesNoRadioButton = ({
  label,
  isHorizontal = false,
  required,
  disabled = false,
}: YesNoRadioButtonProps) => {
  const field = useFieldContext<boolean>();

  return (
    <FormControl disabled={disabled}>
      <FormLabel
        id={`${label}-radio-buttons-group-label`}
        color="primary"
        required={required}
      >
        {label}
      </FormLabel>
      <RadioGroup
        aria-labelledby={`${label}-radio-buttons-group-label`}
        value={field.state.value ?? ""}
        name={`${label}-radio-buttons-group`}
        onChange={(e) => field.handleChange(e.target.value === "true")}
        row={isHorizontal}
      >
        {YES_NO_OPTIONS.map((option) => (
          <FormControlLabel
            key={option.label}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      <ErrorMessage />
    </FormControl>
  );
};
export default YesNoRadioButton;
